import { render, staticRenderFns } from "./ldyCfg.vue?vue&type=template&id=18db75b3&scoped=true&"
import script from "./ldyCfg.vue?vue&type=script&lang=js&"
export * from "./ldyCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db75b3",
  null
  
)

export default component.exports